var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mobile-navigation",
      class: [
        { open: _vm.isMobileNavigationOpen },
        { "d-none": !_vm.isMobileNavigationOpen }
      ]
    },
    [
      [
        _c("div", { staticClass: "d-flex nav-direction" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex-fill text-right",
              on: {
                click: function($event) {
                  return _vm.closeNavigation()
                }
              }
            },
            [_c("i", { staticClass: "fa fa-times" })]
          )
        ]),
        _vm._v(" "),
        _c(
          "ul",
          {
            directives: [{ name: "menu", rawName: "v-menu" }],
            staticClass: "mainmenu w-100 p-0 m-0 menu-active",
            attrs: { id: "menu-1" }
          },
          [
            _vm.breadcrumbs.length == 0
              ? [
                  _c("li", [
                    _c(
                      "span",
                      {
                        staticClass:
                          "nav-direction d-flex align-items-center mHeader"
                      },
                      [
                        _c("div", { staticClass: "flex-fill text-center" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$translate("Woerner::Template.cats")) +
                              "\n             "
                          )
                        ])
                      ]
                    )
                  ])
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.dataContainer1.parent
              ? _c(
                  "li",
                  {
                    staticClass: "ddown",
                    on: {
                      click: function($event) {
                        return _vm.slideTo(
                          (_vm.dataContainer1.parent &&
                            _vm.dataContainer1.parent.parent) ||
                            null,
                          true
                        )
                      }
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "nav-direction d-flex align-items-center mHeader"
                      },
                      [
                        _vm.selectedCat
                          ? [
                              _c("i", {
                                staticClass: "fa fa-long-arrow-left",
                                attrs: { "aria-hidden": "true" }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex-fill text-center" },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.selectedCat.details[0].name) +
                                      "\n                   "
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.dataContainer1.categories, function(category) {
              return _c("li", { staticClass: "ddown" }, [
                _c("a", { attrs: { href: _vm.getCategoryUrl(category.url) } }, [
                  _vm._v(_vm._s(category.details[0].name))
                ]),
                _vm._v(" "),
                category.childCount
                  ? _c(
                      "span",
                      {
                        staticClass: "nav-direction",
                        on: {
                          click: function($event) {
                            return _vm.slideTo(category)
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-angle-right",
                          attrs: { "aria-hidden": "true" }
                        })
                      ]
                    )
                  : _vm._e()
              ])
            }),
            _vm._v(" "),
            _vm.dataContainer1.categories[0]
              ? _vm._l(
                  _vm.dataContainer1.categories[0].siblingCount -
                    _vm.dataContainer1.categories.length,
                  function(number) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c("span", {
                        staticClass: "nav-placeholder m-3",
                        style: { width: Math.random() * 20 + 60 + "%" }
                      })
                    ])
                  }
                )
              : _vm.dataContainer1.parent
              ? _vm._l(_vm.dataContainer1.parent.childCount, function(number) {
                  return _c("li", { staticClass: "ddown" }, [
                    _c("span", {
                      staticClass: "nav-placeholder m-3",
                      style: { width: Math.random() * 20 + 60 + "%" }
                    })
                  ])
                })
              : _vm._e(),
            _vm._v(" "),
            _c("li", [
              _c(
                "span",
                {
                  staticClass: "nav-direction d-flex align-items-center mHeader"
                },
                [
                  _c("div", { staticClass: "flex-fill text-center" }, [
                    _vm._v(
                      "\n               " +
                        _vm._s(_vm.$translate("Woerner::Template.other")) +
                        "\n            "
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "ddown" }, [
              _c("a", { attrs: { href: _vm.urlKatalog, rel: "nofollow" } }, [
                _c("i", {
                  staticClass: "fa fa-book mr-2 icons-mobile",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$translate("Woerner::Template.katalogmobile")) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "ddown" }, [
              _c("a", { attrs: { href: _vm.urlNewsletter, rel: "nofollow" } }, [
                _c("i", {
                  staticClass: "fa fa-envelope mr-2 icons-mobile smaller",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$translate("Woerner::Template.nlmobile")) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "ddown" }, [
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.urlPhone,
                    target: "_blank",
                    rel: "nofollow"
                  }
                },
                [
                  _c("i", {
                    staticClass: "fa fa-phone mr-2 icons-mobile",
                    attrs: { "aria-hidden": "true" }
                  }),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$translate("Woerner::Template.phonemobile")) +
                      "\n        "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _c(
                "span",
                {
                  staticClass: "nav-direction d-flex align-items-center mHeader"
                },
                [
                  _c("div", { staticClass: "flex-fill text-center" }, [
                    _vm._v(
                      "\n               " +
                        _vm._s(_vm.$translate("Woerner::Template.lang")) +
                        "\n            "
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "ddown" }, [
              _c("a", { attrs: { href: _vm.langURLs.de } }, [
                _c("img", {
                  staticClass: "mr-3",
                  attrs: {
                    src:
                      "https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/flags/DE_2x.png",
                    title: _vm.$translate("Woerner::Template.german"),
                    alt: "language-german",
                    loading: "lazy"
                  }
                }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$translate("Woerner::Template.german")) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "ddown" }, [
              _c("a", { attrs: { href: _vm.langURLs.en } }, [
                _c("img", {
                  staticClass: "mr-3",
                  attrs: {
                    src:
                      "https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/flags/GB_2x.png",
                    title: _vm.$translate("Woerner::Template.englisch"),
                    alt: "language-english",
                    loading: "lazy"
                  }
                }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$translate("Woerner::Template.englisch")) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "ddown" }, [
              _c("a", { attrs: { href: _vm.langURLs.fr } }, [
                _c("img", {
                  staticClass: "mr-3",
                  attrs: {
                    src:
                      "https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/flags/FR_2x.png",
                    title: _vm.$translate("Woerner::Template.franz"),
                    alt: "language-french"
                  }
                }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$translate("Woerner::Template.franz")) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "ddown" }, [
              _c("a", { attrs: { href: _vm.langURLs.es } }, [
                _c("img", {
                  staticClass: "mr-3",
                  attrs: {
                    src:
                      "https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/flags/ES_2x.png",
                    title: _vm.$translate("Woerner::Template.spain"),
                    alt: "language-spanish",
                    loading: "lazy"
                  }
                }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$translate("Woerner::Template.spain")) +
                    "\n        "
                )
              ])
            ])
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "ul",
          {
            directives: [{ name: "menu", rawName: "v-menu" }],
            staticClass: "mainmenu w-100 p-0 m-0",
            attrs: { id: "menu-2" }
          },
          [
            _vm.breadcrumbs.length == 0
              ? [
                  _c("li", [
                    _c(
                      "span",
                      {
                        staticClass:
                          "nav-direction d-flex align-items-center mHeader"
                      },
                      [
                        _c("div", { staticClass: "flex-fill text-center" }, [
                          _vm._v(
                            "\n                      " +
                              _vm._s(_vm.$translate("Woerner::Template.cats")) +
                              "\n                   "
                          )
                        ])
                      ]
                    )
                  ])
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.dataContainer2.parent
              ? _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        return _vm.slideTo(
                          (_vm.dataContainer2.parent &&
                            _vm.dataContainer2.parent.parent) ||
                            null,
                          true
                        )
                      }
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "nav-direction d-flex align-items-center mHeader"
                      },
                      [
                        _vm.selectedCat
                          ? [
                              _c("i", {
                                staticClass: "fa fa-long-arrow-left",
                                attrs: { "aria-hidden": "true" }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex-fill text-center" },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.selectedCat.details[0].name) +
                                      "\n                   "
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.dataContainer2.categories, function(category) {
              return _c("li", { staticClass: "ddown" }, [
                _c("a", { attrs: { href: _vm.getCategoryUrl(category.url) } }, [
                  _vm._v(_vm._s(category.details[0].name))
                ]),
                _vm._v(" "),
                category.childCount
                  ? _c(
                      "span",
                      {
                        staticClass: "nav-direction",
                        on: {
                          click: function($event) {
                            return _vm.slideTo(category)
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-lg fa-angle-right",
                          attrs: { "aria-hidden": "true" }
                        })
                      ]
                    )
                  : _vm._e()
              ])
            }),
            _vm._v(" "),
            _vm.dataContainer2.categories[0]
              ? _vm._l(
                  _vm.dataContainer2.categories[0].siblingCount -
                    _vm.dataContainer2.categories.length,
                  function(number) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c("span", {
                        staticClass: "nav-placeholder m-3",
                        style: { width: Math.random() * 20 + 60 + "%" }
                      })
                    ])
                  }
                )
              : _vm.dataContainer2.parent
              ? _vm._l(_vm.dataContainer2.parent.childCount, function(number) {
                  return _c("li", { staticClass: "ddown" }, [
                    _c("span", {
                      staticClass: "nav-placeholder m-3",
                      style: { width: Math.random() * 20 + 60 + "%" }
                    })
                  ])
                })
              : _vm._e(),
            _vm._v(" "),
            _c("li", [
              _c(
                "span",
                {
                  staticClass: "nav-direction d-flex align-items-center mHeader"
                },
                [
                  _c("div", { staticClass: "flex-fill text-center" }, [
                    _vm._v(
                      "\n                   " +
                        _vm._s(_vm.$translate("Woerner::Template.other")) +
                        "\n                "
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "ddown" }, [
              _c("a", { attrs: { href: _vm.urlKatalog, rel: "nofollow" } }, [
                _c("i", {
                  staticClass: "fa fa-book mr-2 icons-mobile",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$translate("Woerner::Template.katalogmobile")) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "ddown" }, [
              _c("a", { attrs: { href: _vm.urlNewsletter, rel: "nofollow" } }, [
                _c("i", {
                  staticClass: "fa fa-envelope mr-2 icons-mobile smaller",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$translate("Woerner::Template.nlmobile")) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "ddown" }, [
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.urlPhone,
                    target: "_blank",
                    rel: "nofollow"
                  }
                },
                [
                  _c("i", {
                    staticClass: "fa fa-phone mr-2 icons-mobile",
                    attrs: { "aria-hidden": "true" }
                  }),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$translate("Woerner::Template.phonemobile")) +
                      "\n        "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _c(
                "span",
                {
                  staticClass: "nav-direction d-flex align-items-center mHeader"
                },
                [
                  _c("div", { staticClass: "flex-fill text-center" }, [
                    _vm._v(
                      "\n             " +
                        _vm._s(_vm.$translate("Woerner::Template.lang")) +
                        "\n          "
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "ddown" }, [
              _c("a", { attrs: { href: _vm.langURLs.de } }, [
                _c("img", {
                  staticClass: "mr-3",
                  attrs: {
                    src:
                      "https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/flags/DE_2x.png",
                    title: _vm.$translate("Woerner::Template.german"),
                    alt: "language-german",
                    loading: "lazy"
                  }
                }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$translate("Woerner::Template.german")) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "ddown" }, [
              _c("a", { attrs: { href: _vm.langURLs.en } }, [
                _c("img", {
                  staticClass: "mr-3",
                  attrs: {
                    src:
                      "https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/flags/GB_2x.png",
                    title: _vm.$translate("Woerner::Template.englisch"),
                    alt: "language-english",
                    loading: "lazy"
                  }
                }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$translate("Woerner::Template.englisch")) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "ddown" }, [
              _c("a", { attrs: { href: _vm.langURLs.fr } }, [
                _c("img", {
                  staticClass: "mr-3",
                  attrs: {
                    src:
                      "https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/flags/FR_2x.png",
                    title: _vm.$translate("Woerner::Template.franz"),
                    alt: "language-french",
                    loading: "lazy"
                  }
                }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$translate("Woerner::Template.franz")) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "ddown" }, [
              _c("a", { attrs: { href: _vm.langURLs.es } }, [
                _c("img", {
                  staticClass: "mr-3",
                  attrs: {
                    src:
                      "https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/flags/ES_2x.png",
                    title: _vm.$translate("Woerner::Template.spain"),
                    alt: "language-spanish",
                    loading: "lazy"
                  }
                }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$translate("Woerner::Template.spain")) +
                    "\n        "
                )
              ])
            ])
          ],
          2
        )
      ],
      _vm._v(" "),
      !_vm.isNavigationInitialized
        ? [
            _c("div", { staticClass: "d-flex" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      return _vm.closeNavigation()
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-times" })]
              )
            ]),
            _vm._v(" "),
            _c("loading-animation")
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        staticStyle: { "max-height": "30px" },
        attrs: {
          alt: "DekoWoerner",
          loading: "lazy",
          src:
            "https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/Logo/decowoerner.svg"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-fill" }, [
      _c("img", {
        staticStyle: { "max-height": "30px" },
        attrs: {
          alt: "DekoWoerner",
          src:
            "https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/dekowoerner.svg"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }